import { useQuery } from "@tanstack/react-query";
import { workspaceService } from "@/services/workspaceService";
import { Workspace } from "@/components/UI/TableToolbar/WorkspaceButton/workspace";
import { useScopeParams } from "./useScopeParams";

export const useWorkspacesQuery = (
  tableName: string,
  dataSection: string = "all",
) => {
  const { scope, id } = useScopeParams();
  const isAdminScope = scope === "admin";
  const enabled = isAdminScope || !!id;

  const workspacesQuery = useQuery({
    queryKey: ["workspaces", id, tableName, dataSection],
    queryFn: async () => {
      if (!enabled) return [];
      return await workspaceService.getWorkspaces(
        scope,
        id,
        tableName,
        dataSection,
      );
    },
    enabled,
    staleTime: 5 * 60 * 1000,
    refetchOnMount: "always",
    refetchOnWindowFocus: "always",
    retry: 2,
  });

  return {
    workspaces: (workspacesQuery.data || []) as Workspace[],
    isLoading: workspacesQuery.isLoading,
    error: workspacesQuery.error,
    refetch: workspacesQuery.refetch,
  };
};
